// extracted by mini-css-extract-plugin
export default {"systemLandscapeHeader":"SystemLandscapeSection_systemLandscapeHeader__r-5qQ"};